/**
 * jquery-doubleTapToGo plugin (edited version)
 * @version 1.0.0
 * @original https://github.com/dachcom-digital/jquery-doubletaptogo
 */
(function ($, window, document, undefined) {
  'use strict';
  var pluginName = 'doubleTapToGo',
      defaults = {
          selectorClass: 'doubletap',
          selectorPrefix: '',
          selectorNodeType: 'li'
      };

  function DoubleTapToGo (element, options) {
      this.element = element;
      this.settings = $.extend({}, defaults, options);
      this._defaults = defaults;
      this._name = pluginName;
      this.init();
  }

  $.extend(DoubleTapToGo.prototype, {
      preventClick: false,
      currentTap: $(),
      init: function () {
          $(this.element)
              .on('touchstart', this.settings.selectorPrefix + '.' + this.settings.selectorClass, this._tap.bind(this))
              .on('click', this.settings.selectorPrefix + '.' + this.settings.selectorClass, this._click.bind(this))
              .on('remove', this._destroy.bind(this));
      },

      _click: function (event) {
          if (this.preventClick) {
              event.preventDefault();
          } else {
              this.currentTap = $();
          }
      },

      _tap: function (event) {
          var $target = $(event.target).closest(this.settings.selectorNodeType);
          if (!$target.hasClass(this.settings.selectorClass)) {
              this.preventClick = false;
              return;
          }
          if ($target.get(0) === this.currentTap.get(0)) {
              this.preventClick = false;
              return;
          }
          this.preventClick = true;
          this.currentTap = $target;
          event.stopPropagation();
      },

      _destroy: function () {
          $(this.element).off();
      },

      reset: function () {
          this.currentTap = $();
      }
  });

  $.fn[pluginName] = function (options) {
      var args = arguments,
          returns;
      if (options === undefined || typeof options === 'object') {
          return this.each(function () {
              if (!$.data(this, pluginName)) {
                  $.data(this, pluginName, new DoubleTapToGo(this, options));
              }
          });
      } else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
          this.each(function () {
              var instance = $.data(this, pluginName),
                  methodName = (options === 'destroy' ? '_destroy' : options);
              if (instance instanceof DoubleTapToGo && typeof instance[methodName] === 'function') {
                  returns = instance[methodName].apply(instance, Array.prototype.slice.call(args, 1));
              }
              if (options === 'destroy') {
                  $.data(this, pluginName, null);
              }
          });
          return returns !== undefined ? returns : this;
      }
  };
})(jQuery, window, document);


// init doubleTapToGo
var dttgInstance = $('.navigation').doubleTapToGo({
  selectorPrefix: '.navigation__item',
  selectorClass: 'has-children'
});

// reset the doupleTapToGo state if something else is focussed/tapped
$('html').on('touchstart', function() {
  dttgInstance.doubleTapToGo('reset');
});
